import { render, staticRenderFns } from "./initDataUpload.vue?vue&type=template&id=4c889674&scoped=true"
import script from "./initDataUpload.vue?vue&type=script&lang=js"
export * from "./initDataUpload.vue?vue&type=script&lang=js"
import style0 from "./initDataUpload.vue?vue&type=style&index=0&id=4c889674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c889674",
  null
  
)

export default component.exports